/** 存放需要使用store的函数,确保在store加载完后，再调用 */
import store from '../store';

/**
 * 通过路由查找对应菜单，并返回数组
 * @param val 路由path
 * @returns [一级菜单名称，二级菜单名称，三级菜单名称, ...]
 */
export const findMenuModelNames = <
  T extends {
    subResources: any[];
    frontUrl: string;
    resourceName: string;
  },
>(
  val: string,
) => {
  const tree: T[] = store.getters.menus;
  let modelNames: T[] = [];
  function recursion(val: string, arr: T[], names: T[] = [], level = 1) {
    if (!Array.isArray(arr) || arr.length === 0) {
      return
    }
    for (const v of arr) {
      if (level === 1) {
        names = [];
      }
      if (v.subResources && v.subResources.length) {
        names.push(v);
        recursion(val, v.subResources, names, level + 1);
      } else if (v.frontUrl === val) {
        names.push(v);
        modelNames = names;
        return;
      }
    }
  }
  recursion(val, tree);
  return modelNames;
};
